<script lang="ts" setup>
import { onMounted } from 'vue';
import SidebarMenu from '@/components/SidebarMenu';
import Nav from '@/components/Nav';
import MessageCenter from '@/components/MessageCenter';
import { useChurnZero, useTrackEvent } from '@/composables';
import { useAuthStore } from '@/store';
import { useRouting } from '@/composables';
import { AuthUserInterface } from '@/types';

const $routing = useRouting();
const useAuth = useAuthStore();

$routing.routeChangeWatcher(() => {
  useChurnZero(useAuth.user as AuthUserInterface, useAuth.organizationExternalId as string);
  useTrackEvent($routing?.route?.name as string);
});

onMounted(() => {
  useChurnZero(useAuth.user as AuthUserInterface, useAuth.organizationExternalId as string);
});
</script>

<template>
  <div id="default-layout">
    <div id="main-container">
      <div id="main-container-scroll" class="flex flex-column h-screen overflow-auto">
        <Nav class="sticky top-0 left-0 mb-2" />
        <div id="main-content">
          <div class="flex max-width">
            <SidebarMenu />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
  <MessageCenter />
</template>

<style lang="scss" scoped>
.max-width {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
}
</style>
